import { ReactElement } from 'react'
import ContactAdminScreen from 'src/features/login/ContactAdminScreen'

const ContactAdmin = (): ReactElement => {
  return <ContactAdminScreen />
}

export default ContactAdmin
